import {axiosHttp} from '@/util/axios.js'


/**
 * 查询购物车数据
 */
export function searchShoppingCart(){
  return axiosHttp.$getAxios('/getMyShoppingCart')
}

/**
 * 添加进购物车
 * @param { merchantCode } data 
 */
export function addGoodsToCart(data){
  return axiosHttp.$postAxios('/addGoodsToCart', data)
}


/**
 * 删除购物车商品
 * @param { merchantCode } data 
 * 
 */
export function deleteShoppingCartGoods(data){
  return axiosHttp.$postAxios('/deleteShoppingCartGoods', data)
}

// 批量删除购物车商品
export function deleteShopCartByBatch(data){
  return axiosHttp.$postAxios('/deleteShopCartByBatch', data)
}








// WEBPACK FOOTER //
// ./src/apis/shoppingCart/shoppingCart.js